import { IconButton, Tooltip } from "@material-ui/core";
import { IconButtonProps } from "@material-ui/core/IconButton";
import { createStyles, CSSProperties, makeStyles } from "@material-ui/styles";
import classnames from "classnames";
import * as React from "react";

import { Label, RelodeTheme } from "..";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            ...{
                root: {
                    padding: theme.spacing(1),
                    "& svg": {
                        alignSelf: "center",
                    },
                },
                negative: {
                    margin: "auto",
                    color: theme.relode.colors.negativeAction.contrastText,
                    backgroundColor: theme.relode.colors.negativeAction.main, //
                    "&:hover": {
                        backgroundColor:
                            theme.relode.colors.negativeAction.dark, //
                    },
                },
                negativeDisabled: {
                    margin: "auto",
                    backgroundColor: theme.relode.colors.negativeAction.light,
                },
                positive: {
                    margin: "auto",
                    color: theme.relode.colors.positiveAction.contrastText,
                    backgroundColor: theme.relode.colors.positiveAction.main,
                    "&:hover": {
                        backgroundColor:
                            theme.relode.colors.positiveAction.dark,
                    },
                },
                positiveDisabled: {
                    margin: "auto",
                    backgroundColor: theme.relode.colors.positiveAction.light,
                },
                buttonContainer: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                },
                buttonMarginRight: {
                    marginRight: theme.spacing(2),
                },
                buttonMarginLeft: {
                    marginLeft: theme.spacing(2),
                },
            },
            ...theme.relode.controls.pageActionButton,
        }),
    { name: "LabeledPageActionButton" }
);

type LabeledPageActionButtonCSSProperties =
    | "root"
    | "negative"
    | "negativeDisabled"
    | "positive"
    | "positiveDisabled";
export type LabeledPageActionButtonStyles = Partial<
    Record<
        LabeledPageActionButtonCSSProperties,
        CSSProperties | ((props?: {}) => CSSProperties)
    >
>;

interface InnerPageActionButtonProps {
    actionType?: "positive" | "negative";
    label: string;
    marginRight?: boolean;
    marginLeft?: boolean;
}

type LabeledPageActionButtonProps = InnerPageActionButtonProps &
    IconButtonProps;

export const LabeledPageActionButton = (
    props: LabeledPageActionButtonProps
) => {
    const {
        id,
        title,
        disabled,
        className: classNameProp,
        color,
        children,
        actionType,
        label,
        marginRight = false,
        marginLeft = false,
        ...rest
    } = props;

    const classes = useStyles({});

    const rootClassNames = classnames(
        {
            [classes.root]: true,
            [classes.negative]:
                !!actionType && actionType === "negative" && !disabled,
            [classes.negativeDisabled]:
                !!actionType && actionType === "negative" && disabled,
            [classes.positive]:
                !!actionType && actionType === "positive" && !disabled,
            [classes.positiveDisabled]:
                !!actionType && actionType === "positive" && disabled,
        },
        classNameProp
    );

    // TODO: rootClassNames should be these!
    const buttonClassNames = classnames({
        [classes.buttonContainer]: true,
        [classes.buttonMarginRight]: marginRight,
        [classes.buttonMarginLeft]: marginLeft,
    });

    return (
        <Tooltip
            placement="bottom-start"
            title={(!disabled && title) || ""}
            disableFocusListener
        >
            <span className={buttonClassNames}>
                <IconButton
                    id={id}
                    disabled={disabled}
                    className={rootClassNames}
                    color={color}
                    {...rest}
                >
                    {children}
                </IconButton>
                <Label label={label} />
            </span>
        </Tooltip>
    );
};
